import gemsToPoints from '../../airtable/exchange/GemsToPoints';
import gemsToEnergy from '../../airtable/exchange/GemsToEnergy';

/**
 * Max energy amount
 */
export const maxEnergy = 5;

/**
 * Max energy that can be claimed from in-game rewards (e.g. friend invites)
 */
export const maxRewardedEnergy = 99;

// Gems exchange config rates type
export type GemsExchangeRateConfig = {
  readonly items: number;
  readonly bonus: number;
  readonly premium: number;
};

/**
 * Get gems exchange rate
 */
export function getGemsToPointsExchangeRates(): GemsExchangeRateConfig[] {
  return gemsToPoints;
}

/**
 * Get energy exchange rate
 */
export function getGemsToEnergyExchangeRates(): GemsExchangeRateConfig[] {
  return gemsToEnergy;
}

type CurrencyGrantFeature =
  | {
      feature:
        | 'debut'
        | 'care_action'
        | 'visit'
        | 'tutorial_reward'
        | 'currency_exchange'
        | 'minigame_play'
        | 'minigame_reward';
      $subFeature: string;
    }
  | {
      feature:
        | 'invite_reward'
        | 'share_reward'
        | 'share_success_reward'
        | 'energy_refill'
        | 'player_level_up'
        | 'friend_visit_reward';
    };

export type Currencies = {
  points: number;
  energy: number;
  freeGems: number;
  paidGems: number;
};

export const getCurrencyGrantEvent = (
  type: CurrencyGrantFeature,
  currencies: {
    old: Currencies;
    new: Currencies;
  },
) => {
  const {
    points: oldBPoints,
    energy: oldEnergy,
    freeGems: oldFreeGems,
    paidGems: oldPaidGems,
  } = currencies.old;
  const oldTotalGems = oldFreeGems + oldPaidGems;
  const {
    points: newBPoints,
    energy: newEnergy,
    freeGems: newFreeGems,
    paidGems: newPaidGems,
  } = currencies.new;
  const newTotalGems = newFreeGems + newPaidGems;
  return {
    eventType: 'CurrencyGrant',
    eventProperties: {
      ...type,
      oldFreeGems,
      newFreeGems,
      oldPaidGems,
      newPaidGems,
      oldTotalGems,
      newTotalGems,
      freeGemsGranted: newFreeGems - oldFreeGems,
      paidGemsGranted: newPaidGems - oldPaidGems,
      totalGemsGranted: newTotalGems - oldTotalGems,
      oldBPoints,
      newBPoints,
      bPointsGranted: newBPoints - oldBPoints,
      oldEnergy,
      newEnergy,
      energyGranted: newEnergy - oldEnergy,
    },
  };
};
